import makeClasses from "./styles";
import React from "react";
import { Tooltip as MUITooltip } from "@material-ui/core";

const Tooltip = ({ title, children }) => {
  const classes = makeClasses();

  return (
    <MUITooltip
      classes={{
        tooltip: classes.tooltipCustom,
      }}
      enterTouchDelay={0}
      title={title}
      placement="bottom-start"
      PopperProps={{
        modifiers: {
          offset: {
            enabled: true,
            offset: "10, -25",
          },
          flip: {
            enabled: false,
          },
          overflow: {
            enabled: false,
          },
        },
      }}>
      {children}
    </MUITooltip>
  );
};

export default Tooltip;
